export default __webpack_public_path__ + "97aa3fe56614d050102820d56197815e.svg";